import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Component, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';

import { CustomCellParams } from '../../../models/custom-cell.params';

@Component({
  standalone: true,
  selector: 'grid-engine-color-cell',
  templateUrl: './color-cell.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./color-cell.component.scss']
})
export class ColorCellComponent implements ICellRendererAngularComp {
  params: WritableSignal<CustomCellParams> = signal(null);

  agInit(params: CustomCellParams): void {
    this.params.set(params);
  }

  refresh(): boolean {
    return false;
  }
}
